import * as rq from '@tanstack/react-query';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { useDependencies } from '../contexts/dependencies.context';

export namespace GetConditionViolationTimeseriesData {
  export const key = (input: Input, repository: IWarrantyRepository) => [
    'warranty',
    'get-condition-violation-timeseries-data',
    repository.key,
    input.filters,
    input.assetFullFrontendId,
    input.assetId,
  ];

  export type Params = { refetchInterval?: number };
  export type Input =
    IWarrantyRepository.GetConditionViolationTimeseriesDataInput;
  export type Output =
    IWarrantyRepository.GetConditionViolationTimeseriesDataOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input, repositories.warranty),
      queryFn: () =>
        repositories.warranty.getConditionViolationTimeseriesData(input),
    });
  }
}
